import { render, staticRenderFns } from "./LayoutMini.vue?vue&type=template&id=24909b64&scoped=true&"
import script from "./LayoutMini.vue?vue&type=script&lang=js&"
export * from "./LayoutMini.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMini.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LayoutMini.vue?vue&type=style&index=1&id=24909b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24909b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VContainer,VIcon,VMain,VNavigationDrawer})
